import React from "react";
import "./DevelopmentStyle.scss";
import { developmentTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";
import EmailSection from "components/EmailSection";

const DevelopmentSection = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/contact-us`);
  };

  return (
    <section className="development-section">
      <div className="development-wrap">
        <SectionHeading>{developmentTextContent.headingText}</SectionHeading>

        <div className="development-box">
          <div className="cards-grid">
            {developmentTextContent.content.map((section, index) => (
              <div className="development-card" key={index}>
                <div className="development-card-header">
                  <h5 className="title-text">{section.titleText}</h5>
                </div>

                <div className="development-card-body">
                  <h6 className="subtitle-text">{section.subtitleText}</h6>

                  {section.listContent && section.listContent.length > 0 && (
                    <ul className="list-text-box">
                      {section.listContent.map((item, itemIndex) => (
                        <li className="list-text" key={itemIndex}>{item.listText}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
          {/* <EmailSection /> */}

          {/* <div className="btn-box">
            <CustomButton
              buttonType="secondary"
              label={developmentTextContent.btnText}
              onClick={handleButtonClick}
            />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default DevelopmentSection;
